import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex justify-content-between" }
const _hoisted_4 = { class: "w-10" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" for the data source to enable the device. ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex justify-content-end" }

import ProgressBar from "primevue/progressbar";
import InputSwitch from "primevue/inputswitch";
import InlineMessage from "primevue/inlinemessage";
import Card from "primevue/card";
import { ref, watch, computed } from "vue";
import { BoxResponse, UpdateBoxDto } from "@evolutivelabs/quokka-common";
import { useDeviceStore } from "@/store/device.store";

export default /*#__PURE__*/_defineComponent({
  props: {
    box: null
  },
  emits: ["edit-box"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: "edit-box"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  box: BoxResponse;
}


const enableBox = ref(props.box.enable);
const deviceStore = useDeviceStore();
watch(enableBox, (newStatus) => {
  const updateDto = new UpdateBoxDto();
  updateDto.enable = newStatus;
  deviceStore.updateBox(props.box.id, updateDto);
});
const goalTarget = computed(() => {
  const goals = [...props.box.targets, ...props.box.combinedTargets];
  return goals.length > 0 ? goals[0] : undefined;
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "shadow-2 m-3 w-3" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(__props.box.name), 1),
        _createElementVNode("div", {
          class: "pi pi-cog cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('edit-box')))
        })
      ])
    ]),
    content: _withCtx(() => [
      (_unref(goalTarget) !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(goalTarget)?.title) + ": " + _toDisplayString(_unref(goalTarget)?.value), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(goalTarget) !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(goalTarget)?.goalTriggerValue === 0)
                  ? (_openBlock(), _createBlock(_unref(InlineMessage), {
                      key: 0,
                      class: "text-sm",
                      severity: "warn"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createElementVNode("span", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`targets?t=${_unref(goalTarget)?.id}`))),
                          class: "font-semibold underline cursor-pointer"
                        }, "set the goal"),
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(ProgressBar), {
                        value: 
                  (_unref(goalTarget)?.value / _unref(goalTarget)?.goalTriggerValue) * 100
                ,
                        "show-value": true
                      }, null, 8, ["value"]),
                      _createElementVNode("div", _hoisted_9, " goal: " + _toDisplayString(_unref(goalTarget)?.goalTriggerValue), 1)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(InputSwitch), {
          modelValue: enableBox.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((enableBox).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}
}

})